const useExtraScript = () => {
    const { isMrbilit } = useWhiteLabel();
    if (isMrbilit.value) {
        useSchemaOrg([
            defineOrganization({
                '@context': 'http://schema.org',
                '@type': 'Organization',
                name: 'mrBilit',
                url: 'https://mrbilit.com',
                sameAs: [
                    'https://www.instagram.com/mrbilit',
                    'https://www.linkedin.com/company/mrbilit',
                    'https://twitter.com/mrbilit',
                ],
                contactPoint: {
                    '@type': 'ContactPoint',
                    telephone: '+982161169000',
                    contactType: 'customer service',
                },
                logo: 'https://mrbilit.com/img/mrbilit-logo-with-name.png',
            }),
        ]);

        if (!process.client || !(window as any).yektanet) {
            useScriptTag(
                '/js/yektanet.js',
                (_el: HTMLScriptElement) => {
                    // do something
                },
                {
                    async: true,
                    defer: true,
                    type: 'text/javascript',
                    attrs: {
                        id: 'ua-script-yn-1493-adv',
                        'data-analyticsobject': 'yektanet',
                    },
                }
            );
        }
        // if (
        //     !process.client ||
        //     !(window as any).mediaadRetargetingScriptLoaded
        // ) {
        //     useScriptTag(
        //         `/js/serve/34001/retargeting.js`,
        //         (_el: HTMLScriptElement) => {},
        //         {
        //             async: true,
        //             defer: true,
        //             type: 'text/javascript',
        //         }
        //     );
        // }
    }
};

export default useExtraScript;
